import { isMembershipType } from './isMembershipType';
export const isMembershipAdmin = (membership: {
  memberType: 'admin' | 'normal' | 'observer';
}): boolean => isMembershipType(membership, 'admin');
